<sim-basic-material-dialog
	(closeClicked)="
		close({
			action: 'close',
			trainingRoomSelection: data.preselectedTrainingRooms,
		})
	"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[headerIcon]="{fontIcon: 'fa-th', fontSet: 'fad'}"
	[headerText]="T.DETAILED_ROOM_SELECTION_DIALOG_HEADER | translate"
	class="normalDuotoneHeaderIcon"
>
	<div dialogContent style="flex: 1">
		<sim-training-room-navigation-panel
			[singleRoom]="data?.singleRoom"
			[expandAllCards]="true"
			[enableDraggingRooms]="false"
			[planView]="planView"
			[selectedTrainingRooms]="data?.preselectedTrainingRooms"
			[collapseAllCards]="planView"
			[inputFilterRoomIds]="data.excludeRoomIds"
			(onTrainingRoomClicked)="selectTrainingRoom($event)"
			[allowSelectionWhenOccupied]="true"
			[trainingRoomWhitelist]="null"
		>
			<span planViewToggle>
				<sim-segmented-button>
					<sim-button-segment
						(onClick)="onRoomPlannerToggle(false)"
						[icon]="{fontSet: 'fad', fontIcon: 'fa-list-ul'}"
						[matTooltip]="T.DETAILED_ROOM_SELECTION_DIALOG_SHOW_ROOMS_LIST | translate"
						matTooltipClass="'accent'"
					/>
					<sim-button-segment
						(onClick)="onRoomPlannerToggle(true)"
						[icon]="{fontSet: 'fas', fontIcon: 'fa-star'}"
						[matTooltip]="T.DETAILED_ROOM_SELECTION_DIALOG_SHOW_ROOMS_PLAN | translate"
						matTooltipClass="'accent'"
					/>
				</sim-segmented-button>
			</span>
		</sim-training-room-navigation-panel>
	</div>
</sim-basic-material-dialog>
